const fields = [
  {
    dataIndex: 'index',
    key: 'index',
    title: '序号',
    width: 80,
    scopedSlots: {
      customRender: 'subscript'
    }
  },
  {
    dataIndex: 'title',
    key: 'title',
    title: '文章标题',
    scopedSlots: {
      customRender: 'TextAction'
    }
  },
  {
    dataIndex: 'informationTypeStr',
    key: 'informationType',
    width: 100,
    title: '文章类型'
  },
  {
    dataIndex: 'publishTime',
    key: 'publishTime',
    title: '发布日期',
    width: 120
  },
  // {
  //   dataIndex: 'createTime',
  //   key: 'createTime',
  //   title: '创建日期',
  //   width: 120,
  // },
  {
    dataIndex: 'statusStr',
    key: 'statusStr',
    title: '状态',
    width: 100,
    scopedSlots: {
      customRender: 'color'
    }
  },
  {
    title: '操作',
    key: 'action',
    fixed: 'right',
    scopedSlots: {
      customRender: 'action'
    }
  }
]

const formRow = [
  {
    span: 12,
    label: '文章标题',
    component: 'AInput',
    placeholder: '请输入文章标题',
    prop: 'title',
    allowClear: true
  },
  {
    span: 7,
    label: '文章类型',
    component: 'ASelect',
    placeholder: '请选择文章类型',
    prop: 'informationType',
    loading: false,
    disabled: false,
    isCustomList: true,
    customRequestList(instance) {
      instance.loading = true
      instance.disabled = true
      setTimeout(() => {
        instance.disabled = false
        instance.loading = false
        instance.list = [
          { label: '行业资讯', value: '1' },
          { label: '政策制度', value: '2' },
          { label: '产业分析', value: '3' }
        ]
      }, 1000)
    },
    allowClear: true
  }
]

const slotOpt = [
  {
    slot: 'TextAction',
    component: 'TextAction',
    cb: 'toDetail'
  },
  {
    slot: 'action',
    component: 'Action',
    list: [
      { name: '编辑', cb: 'edit' },
      // { name: '发布', cb: 'issue', divider: true },
      { name: '删除', cb: 'singleDelete', divider: true }
    ]
  }
]

module.exports = {
  fields,
  formRow,
  slotOpt
}
